import { useNavigate, useSearchParams, Link } from "react-router-dom";
import { Layout } from "../components/Layout";
import { useEffect, useState } from "react";
import { Button } from "../components/Button";
import { Input } from "../components/forms";
import { useLocalStorageState } from "../hooks";
import { UNDERLINE_CLASS_LARGE } from "../utils";

export default function AcceptDevSite() {
  const [accepted, setAccepted] = useLocalStorageState(
    "accept-dev-site",
    "dev-not-accepted"
  );
  const [val, setVal] = useState("");
  const [err, setErr] = useState("");
  const navigate = useNavigate();
  const [searchParams] = useSearchParams();

  useEffect(() => {
    const redirectTo = searchParams.get("current-page");

    if (
      accepted &&
      accepted?.startsWith("dev-accepted") &&
      redirectTo
    ) {
      navigate(redirectTo);
    }
  }, [accepted, navigate, searchParams]);

  // // Set page title
  // useEffect(() => {
  //   document.title = "Accept Dev Site | Doridium.com";
  // }, []);

  return (
    <Layout header={{ show: false }} footer={{ show: false }}>
      <h2 className="text-textMain text-center py-10 mb-[10px] text-7xl">
        This is a development site
      </h2>

      <div className="m-5 px-2 text-center text-4xl">
        <p className="">
          If you arrived here on accident and wish to access the production
          site, please proceed to{" "}
          <a
            href="https://doridium.com"
            className={" pointer  " + UNDERLINE_CLASS_LARGE}
          >
            doridium.com
          </a>
        </p>
      </div>

      <div className="m-5 px-2 text-center">
        <p className="">
          If this is you intended destination, please supply the code you were
          provided and submit to proceed.
        </p>
      </div>
      <div className=" px-2 w-1/2 m-auto text-center">
        <Input
          className=""
          label="Code:"
          type="text"
          value={val}
          onChange={(evt) => {
            const { value } = evt.target;
            setVal(value);
          }}
        />
        <Button
          type="submit"
          btnType="large"
          btnColor="primary"
          onClick={() => {
            if (val.length > 15) {
              if (val.startsWith("adad")) {
                setErr("");
                setAccepted(
                  "dev-accepted:DATE" +
                    new Date().toISOString() +
                    ":with" +
                    val
                );
              } else {
                setErr("code is incorrect");
              }
            } else {
              setErr("code is too short");
            }
          }}
        >
          Submit
        </Button>
        <p className="text-warning">{err}</p>
      </div>
    </Layout>
  );
}
